
export const ROUTE_PROFILE = 'profile';
export const ROUTE_ORGANIZATION = 'organization';

export const PAGE_PROFILE = '';





export function absRoute(route: string): string {
  return `/${route}`;
}
